import { EqualValueValidatorDirective } from './equal-value-validator.directive';
import { NgModule } from '@angular/core';
import { MinValueValidatorDirective } from './min-value-validator.directive';
import { OnlyNumbersValidatorDirective } from './only-numbers.validator.directive';
import { MaxValueValidatorDirective } from './max-value-validator.directive';
import { RfcValidatorDirective } from './rfc-validator.directive';
import { MinCharValidatorDirective } from './min-char-validator.directive';
import { NameValidatorDirective } from './name-validator.directive';
import { UrlValidator } from './url-validator.directive';
import { GreaterThanValidatorDirective } from './greater-than-validator.directive';
import { LesserThanValidatorDirective } from './lesser-than-validator.directive';
import { NonZeroValidatorDirective } from './non-zero-validator.directive';
import { BusinessNameValidatorDirective } from './business-name-validator.directive';
import { CityValidatorDirective } from './city-validator.directive';
import { CurpValidatorDirective } from './curp-validator.directive';
import { DateValidatorDirective } from './date-validator.directive';
import { EmailValidatorDirective } from './email-validator.directive';
import { EscrowIdentifierValidatorDirective } from './escrow-identifier-validator.directive';
import { ExternalNumberValidatorDirective } from './external-number-validator.directive';
import { InternalNumberValidatorDirective } from './internal-number-validator.directive';
import { LengthValidatorDirective } from './length-validator.directive';
import { NeighborhoodValidatorDirective } from './neighborhood-validator.directive';
import { PhoneNumberValidatorDirective } from './phone-number-validator.directive';
import { PhysicalPersonFirstNameValidatorDirective } from './physical-first-name-validator.directive';
import { PhysicalPersonLastNameValidatorDirective } from './physical-last-name-validator.directive';
import { StateValidatorDirective } from './state-validator.directive';
import { StreetValidatorDirective } from './street-validator.directive';
import { ZipCodeValidatorDirective } from './zipcode-validator.directive';

@NgModule({
  declarations: [
    MinValueValidatorDirective,
    OnlyNumbersValidatorDirective,
    MaxValueValidatorDirective,
    RfcValidatorDirective,
    MinCharValidatorDirective,
    NameValidatorDirective,
    UrlValidator,
    GreaterThanValidatorDirective,
    LesserThanValidatorDirective,
    NonZeroValidatorDirective,
    EqualValueValidatorDirective,
    BusinessNameValidatorDirective,
    CityValidatorDirective,
    CurpValidatorDirective,
    DateValidatorDirective,
    EmailValidatorDirective,
    EscrowIdentifierValidatorDirective,
    ExternalNumberValidatorDirective,
    InternalNumberValidatorDirective,
    LengthValidatorDirective,
    NameValidatorDirective,
    NeighborhoodValidatorDirective,
    PhoneNumberValidatorDirective,
    PhysicalPersonFirstNameValidatorDirective,
    PhysicalPersonLastNameValidatorDirective,
    RfcValidatorDirective,
    StateValidatorDirective,
    StreetValidatorDirective,
    ZipCodeValidatorDirective,
  ],
  exports: [
    MinValueValidatorDirective,
    OnlyNumbersValidatorDirective,
    MaxValueValidatorDirective,
    RfcValidatorDirective,
    MinCharValidatorDirective,
    NameValidatorDirective,
    UrlValidator,
    GreaterThanValidatorDirective,
    LesserThanValidatorDirective,
    NonZeroValidatorDirective,
    EqualValueValidatorDirective,
    BusinessNameValidatorDirective,
    CityValidatorDirective,
    CurpValidatorDirective,
    DateValidatorDirective,
    EmailValidatorDirective,
    EscrowIdentifierValidatorDirective,
    ExternalNumberValidatorDirective,
    InternalNumberValidatorDirective,
    LengthValidatorDirective,
    NameValidatorDirective,
    NeighborhoodValidatorDirective,
    PhoneNumberValidatorDirective,
    PhysicalPersonFirstNameValidatorDirective,
    PhysicalPersonLastNameValidatorDirective,
    RfcValidatorDirective,
    StateValidatorDirective,
    StreetValidatorDirective,
    ZipCodeValidatorDirective,
  ],
})
export class ValidationsModule {}
